import { type SorterResult } from 'antd/es/table/interface'

import { type Sorter } from '../models'

/**
 * Antdのテーブルからソート条件を取得する
 * @param sorterResult Antdのテーブルから取得したソート条件
 */
export const mapToSorterFromAntdTable = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sorterResult: SorterResult<any> | SorterResult<any>[]
): Sorter | undefined => {
  if (
    // 複数ソートは対応してないので除外
    Array.isArray(sorterResult) ||
    // columnKey が文字列でない場合は除外（React.Keyが渡される）
    typeof sorterResult.columnKey !== 'string'
  ) {
    return undefined
  }

  const { order, columnKey } = sorterResult
  if (order) {
    switch (order) {
      case 'ascend':
        return {
          sort: columnKey,
          order: 'ASC'
        }
      case 'descend':
        return {
          sort: columnKey,
          order: 'DESC'
        }
    }
  } else {
    return {
      sort: undefined,
      order: undefined
    }
  }
}
